export const DEFAULT_DATE_FORMAT = 'EEEE, MMM dd, yyyy';
export const DEFAULT_TIME_FORMAT = 'hh:mm';
